
import React, { Component } from "react"
import { Helmet } from "react-helmet"
import ReactHtmlParser from "react-html-parser"
import ContactForm from "../components/ContactForm"

const pageData = `
    <div class="uk-container uk-container-expand">
      <nav class="uk-navbar-container uk-margin" uk-navbar="offset: 0">
        <div class="uk-navbar-left">
          <a
            class="uk-navbar-item uk-logo uk-padding-remove-left"
            title="Home"
            href="/"
            ><img
              alt="Radioplayer logo"
              src="/images/rp-misc-logo.png"
              class="uk-width-small"
          /></a>
        </div>
        <div class="uk-navbar-right uk-hidden@m">
          <i
            class="fal fa-bars uk-text-large mp-cursor-pointer"
            uk-toggle="target: #rp-offcanvas-nav"
          ></i>
        </div>
        <div class="uk-navbar-right uk-visible@m">
          <ul class="uk-navbar-nav">
            <li class="mp-section-discover">
              <a href="/discover">Discover</a>
            </li>
            <li class="mp-section-docs">
              <a href="/docs/how-to">Documentation</a>
              <div class="uk-navbar-dropdown uk-width-medium">
                <ul class="uk-nav uk-navbar-dropdown-nav" uk-margin>
                  <li>
                    <a class="mp-nav-item" href="/docs/how-to"
                      ><div
                        class="uk-flex-middle uk-grid-small uk-grid"
                        uk-grid
                      >
                        <div class="uk-width-auto">
                          <i class="fal fa-question"></i>
                        </div>
                        <div class="uk-width-expand">How-To Guides</div>
                      </div></a
                    >
                  </li>
                  <li>
                    <a class="mp-nav-item" href="/api-reference"
                      ><div
                        class="uk-flex-middle uk-grid-small uk-grid"
                        uk-grid
                      >
                        <div class="uk-width-auto">
                          <i class="fal fa-code"></i>
                        </div>
                        <div class="uk-width-expand">API Reference</div>
                      </div></a
                    >
                  </li>
                  <li>
                    <a class="mp-nav-item" href="/docs/quick-start"
                      ><div
                        class="uk-flex-middle uk-grid-small uk-grid"
                        uk-grid
                      >
                        <div class="uk-width-auto">
                          <i class="fal fa-paper-plane"></i>
                        </div>
                        <div class="uk-width-expand">Quick Start</div>
                      </div></a
                    >
                  </li>
                  <li>
                    <a class="mp-nav-item" href="/docs/libraries"
                      ><div
                        class="uk-flex-middle uk-grid-small uk-grid"
                        uk-grid
                      >
                        <div class="uk-width-auto">
                          <i class="fal fa-books"></i>
                        </div>
                        <div class="uk-width-expand">Libraries</div>
                      </div></a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="mp-section-console">
              <a href="/console">Console</a>
            </li>
            <li class="mp-section-use-cases">
              <a href="/use-cases">Use Cases</a>
              <div class="uk-navbar-dropdown uk-width-medium">
                <ul class="uk-nav uk-navbar-dropdown-nav" uk-margin>
                  <li>
                    <a
                      class="mp-nav-item"
                      href="/use-cases/hybrid"
                      ><div
                        class="uk-flex-middle uk-grid-small uk-grid"
                        uk-grid
                      >
                        <div class="uk-width-auto">
                          <img
                            alt="Hybrid Car in Radio icon"
                            style="width: 18px;"
                            src="data:image/svg+xml;base64,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"
                          />
                        </div>
                        <div class="uk-width-expand">
                          Hybrid Radio in the Car
                        </div>
                      </div></a
                    >
                  </li>
                  <!--li>
                  <a
                    class="mp-nav-item"
                    href="/use-cases/phonetics"
                    ><div
                      class="uk-flex-middle uk-grid-small uk-grid"
                      uk-grid
                    >
                      <div class="uk-width-auto">
                        <img
                          alt="Hybrid Car in Radio icon"
                          style="width: 18px;"
                          src="data:image/svg+xml;base64,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"
                        />
                      </div>
                      <div class="uk-width-expand">
                        Phonetic Services
                      </div>
                    </div></a
                  >
                </li-->
                </ul>
              </div>
            </li>
          </ul>
          <div class="uk-navbar-item uk-padding-remove-right">
            <a
              class="uk-button uk-button-default uk-flex uk-flex-middle"
              href="https://radioplayer.co.uk/"
              >Back to Radioplayer
             </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="uk-cover-container uk-height-large uk-light">
      <div
        class="mp-overlay-swoosh mp-overlay-swoosh-internal mp-overlay-swoosh-split uk-position-cover mp-z-index-200"
      ></div>
      <img src="/images/hero-contact.jpg" alt="" uk-cover />
      <div
        class="mp-z-index-300 uk-position-relative uk-container uk-container-large uk-height-1-1 uk-flex uk-flex-middle"
      >
        <div
          class="uk-width-3-5@xl uk-width-4-5@l uk-width-4-5@m mp-z-index-200"
        >
          <h1 class="uk-heading-large">Contact Us</h1>
          <h2></h2>
        </div>
        <div
          class="uk-position-bottom-right uk-overlay uk-text-right mp-padding-remove-until@m uk-margin-small-right mp-margin-remove-right@m"
        >

        </div>
      </div>
    </div>
    <div class="uk-container">
      <div class="uk-grid uk-grid-large" uk-grid>


        <article
          class="uk-width-3-4@m mp-content-column mp-margin-remove-top-until@m mp-margin-remove-bottom-until@m"
        >
          <div
            class="uk-grid uk-child-width-1-1 uk-padding uk-padding-remove-horizontal"
            uk-grid
          >
            <section class="mp-section-docs" id="understanding-the-basics">
            <h2>Contact Us</h2>
            `
  const pageData2 = `
  </section>
 </div>
 </div>
 </div>
    <footer
      class="uk-background-secondary uk-light uk-padding uk-padding-remove-horizontal"
    >
      <div class="uk-container uk-container-large">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-1">
            <img
              alt="Radioplayer logo"
              src="/images/rp-misc-logo-inverse.png"
              class="uk-width-1-1@m uk-width-1-2@s uk-width-3-5"
            />
          </div>
          <div class="uk-width-2-5@l uk-width-1-4@m uk-visible@m"></div>
          <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-2">
            <ul class="uk-nav uk-nav-default">
              <li><a href="/discover">Discover</a></li>
              <li><a href="/docs/how-to">Documentation</a></li>
              <li><a href="/console">Console</a></li>
              <li><a href="/use-cases">Use Cases</a></li>
            </ul>
          </div>
          <div class="uk-width-1-5@l uk-width-1-4@m uk-width-1-2">
            <ul class="uk-nav uk-nav-default">
              <li><a href="https://radioplayer.co.uk/privacy">Privacy Policy</a></li>
              <li class="uk-active"><a href="/contact">Contact</a></li>
              <li><a href="https://radioplayer.co.uk/news">News</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <div id="rp-offcanvas-nav" uk-offcanvas="overlay: true">
      <div class="uk-offcanvas-bar">
        <ul class="uk-nav-primary uk-nav-parent-icon" uk-nav>
          <li class="mp-section-discover">
            <a href="/discover">Discover</a>
          </li>
          <li class="mp-section-docs uk-parent">
            <a href="/docs/how-to">Documentation</a>
            <ul class="uk-nav-sub">
              <li><a href>Docs Overview</a></li>
              <li><a href="/docs/how-to">How-To Guides</a></li>
              <li><a href="/api-reference">API Reference</a></li>
              <li><a href="/docs/quick-start">Quick Start</a></li>
              <li><a href>Libraries</a></li>
            </ul>
          </li>
          <li class="mp-section-console">
            <a href="/console">Console</a>
          </li>
          <li class="mp-section-use-cases uk-parent uk-open">
            <a href="#">Use Cases</a>
            <ul class="uk-nav-sub">
              <li><a href="/use-cases">Use Cases Overview</a></li>
              <li class="uk-active">
                <a href="/use-cases/hybrid">Hybrid Radio in the Car</a>
              </li>
            </ul>
          </li>
          <li class="uk-nav-divider"></li>
          <li>
            <ul class="uk-nav-sub uk-padding-remove-left">
              <li><a href="https://radioplayer.co.uk/privacy">Privacy Policy</a></li>
              <li class="uk-active"><a href="/contact">Contact</a></li>
              <li><a href="https://radioplayer.co.uk/news">News</a></li>
              <li class="uk-nav-divider"></li>
              <li>
                <a href="https://www.radioplayer.org">Back to Radioplayer</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
`

class ContactPage extends Component {
    componentDidMount() {
      const scriptMain = document.createElement("script");
      scriptMain.src = "/main.js";
      scriptMain.async = true;
      const scriptFA = document.createElement("script")
      scriptFA.src = "https://kit.fontawesome.com/744611ab32.js"
      scriptFA.async = true;
      scriptFA.crossorigin = "anonymous";
      document.body.appendChild(scriptMain);
      document.body.appendChild(scriptFA);
    }
    render() {
        return(
            <>
        <Helmet>
<meta charset="utf-8" />
    <title>
      Contact Us - Radioplayer Developer Hub
    </title>
    <meta name="description" content="Get in touch with Radioplayer to find out more about our radio broadcast metadata solutions." />
    <script src="https://kit.fontawesome.com/744611ab32.js" crossorigin="anonymous">
    </script>
    <link
        rel="shortcut icon"
        href="/images/favicons/favicon.ico" />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="/images/favicons/favicon-16x16.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="/images/favicons/favicon-32x32.png"
    />
    <link rel="manifest" href="/images/favicons/manifest.json" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="theme-color" content="#fff" />
    <meta name="application-name" content="Radioplayer Dev Doc Templates" />
    <link
      rel="apple-touch-icon"
      sizes="57x57"
      href="/images/favicons/apple-touch-icon-57x57.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="60x60"
      href="/images/favicons/apple-touch-icon-60x60.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="72x72"
      href="/images/favicons/apple-touch-icon-72x72.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="76x76"
      href="/images/favicons/apple-touch-icon-76x76.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="114x114"
      href="/images/favicons/apple-touch-icon-114x114.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="120x120"
      href="/images/favicons/apple-touch-icon-120x120.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="144x144"
      href="/images/favicons/apple-touch-icon-144x144.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="152x152"
      href="/images/favicons/apple-touch-icon-152x152.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="167x167"
      href="/images/favicons/apple-touch-icon-167x167.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/images/favicons/apple-touch-icon-180x180.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="1024x1024"
      href="/images/favicons/apple-touch-icon-1024x1024.png"
    />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta
      name="apple-mobile-web-app-status-bar-style"
      content="black-translucent"
    />
    <meta
      name="apple-mobile-web-app-title"
      content="Radioplayer Dev Doc Templates"
    />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <link href="/style.css" rel="stylesheet" />
        </Helmet>
        {ReactHtmlParser(pageData)}
        <ContactForm />
        {ReactHtmlParser(pageData2)}

      </>  )
    }
}

export default ContactPage

//    <ReactTypeformEmbed  url="https://radioplayer.typeform.com/to/KnkUbH" />
